import AsServedPrompt from './as-served-prompt.vue';
import CerealPrompt from './cereal-prompt.vue';
import DirectWeightPrompt from './direct-weight-prompt.vue';
import DrinkScalePrompt from './drink-scale-prompt.vue';
import GenericBuilderPrompt from './generic-builder-prompt.vue';
import GuideImagePrompt from './guide-image-prompt.vue';
import MilkInAHotDrinkPrompt from './milk-in-a-hot-drink-prompt.vue';
import MilkOnCerealPrompt from './milk-on-cereal-prompt.vue';
import MissingFoodPrompt from './missing-food-prompt.vue';
import ParentFoodPortionPrompt from './parent-food-portion-prompt.vue';
import PizzaPrompt from './pizza-prompt.vue';
import PizzaV2Prompt from './pizza-v2-prompt.vue';
import PortionSizeOptionPrompt from './portion-size-option-prompt.vue';
import RecipeBuilderPrompt from './recipe-builder-prompt.vue';
import StandardPortionPrompt from './standard-portion-prompt.vue';
import UnknownPrompt from './unknown-prompt.vue';

export default {
  AsServedPrompt,
  CerealPrompt,
  DirectWeightPrompt,
  DrinkScalePrompt,
  GenericBuilderPrompt,
  GuideImagePrompt,
  MilkInAHotDrinkPrompt,
  MilkOnCerealPrompt,
  MissingFoodPrompt,
  ParentFoodPortionPrompt,
  PizzaPrompt,
  PizzaV2Prompt,
  PortionSizeOptionPrompt,
  RecipeBuilderPrompt,
  StandardPortionPrompt,
  UnknownPrompt,
};
